import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { ProposedLinkInfoRecords } from "components/curb/map/deckgl/interfaces";

export const GET_PROPOSED_LINKS = "GET_PROPOSED_LINKS";
export const PROPOSED_LINKS_RECEIVED = "PROPOSED_LINKS_RECEIVED";
export const TOGGLE_PROPOSED_CHANGES = "TOGGLE_PROPOSED_CHANGES";
export const SET_PROPOSED_LINKS_FILTERS = "SET_PROPOSED_LINKS_FILTERS";
export const GET_PROPOSED_LINK_INFO = "GET_PROPOSED_LINK_INFO";
export const SET_PROPOSED_LINK_INFO = "SET_PROPOSED_LINK_INFO";
export const TOGGLE_PROPOSED_LAYER = "TOGGLE_PROPOSED_LAYER";

export type GetProposedLinks = {
    time: string;
    date: string;
    scenario_id?: number;
};

export type ProposedLinksReceived = object;
export type ProposedLinksFilterActivity = {
    display_name: string;
    id: number;
    activity: { name: string; id: number };
};
export type ProposedLinksFilters = {
    sub_activity: ProposedLinksFilterActivity | string;
    date: Date;
    time: Date;
};

export interface GetProposedLinksAction {
    type: typeof GET_PROPOSED_LINKS;
    payload: { params: GetProposedLinks };
}

export interface ProposedLinksReceivedAction {
    type: typeof PROPOSED_LINKS_RECEIVED;
    payload: { proposedLinks: ProposedLinksReceived };
}

export interface ToggleProposedChangesAction {
    type: typeof TOGGLE_PROPOSED_CHANGES;
    payload: { toggle: boolean };
}

export interface toggleProposedLayerAction {
    type: typeof TOGGLE_PROPOSED_LAYER;
    payload: { isProposedChanges: boolean };
}

export interface SetProposedLinksFiltersAction {
    type: typeof SET_PROPOSED_LINKS_FILTERS;
    payload: { proposedLinksFilters: ProposedLinksFilters };
}

export interface getProposedLinkInfoAction {
    type: typeof GET_PROPOSED_LINK_INFO;
    payload: { params: number };
}

export interface SetProposedLinkInfoAction {
    type: typeof SET_PROPOSED_LINK_INFO;
    payload: { proposedLinkInfo: ProposedLinkInfoRecords };
}

export type ProposedLinkTypes =
    | GetProposedLinksAction
    | ProposedLinksReceivedAction
    | toggleProposedLayerAction
    | ToggleProposedChangesAction
    | SetProposedLinksFiltersAction
    | getProposedLinkInfoAction
    | SetProposedLinkInfoAction
    | ResetStateAction;

export interface ProposedLinksState {
    isProposedLinksReceived: boolean;
    toggle: boolean;
    proposedLinks: ProposedLinksReceived;
    proposedLinksFilters: ProposedLinksFilters;
    proposedLinkInfo: ProposedLinkInfoRecords;
    isAllProposedLinkInfoReceived: boolean;
    isProposedChanges: boolean;
}
